// Router Dashboard - common
export default [
  {
    path: '',
    name: 'dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../../../views/dashboard/content/common/welcome/Welcome.vue'),
    meta: {
      roles: ['sponsor', 'leader', 'individual', 'OA', 'MAM'],
      navMenuOptions: {
        index: '1',
        label: 'aside.dashboard',
        icon: 'el-icon-s-home',
      },
    },
  },
  {
    path: 'welcome',
    name: 'welcome',
    component: () => import(/* webpackChunkName: "dashboard" */ '../../../views/dashboard/content/common/welcome/Welcome.vue'),
  },
  {
    path: 'settings',
    name: 'userSettings',
    component: () => import(/* webpackChunkName: "dashboard" */ '../../../views/dashboard/content/common/settings/Settings.vue'),
    beforeEnter: (to, from, next) => {
      const storage = localStorage[process.env.VUE_APP_VUEX_KEY]
        ? JSON.parse(localStorage[process.env.VUE_APP_VUEX_KEY])
        : null;
      if (storage && storage.user && storage.user.user && storage.user.user.role_type === 'OA') {
        if (process.env.VUE_APP_COMPONENT_OA_SETTINGS) {
          // ING OA let enter in settings
          next();
        } else if (storage && storage.user && storage.user.organization
          && storage.user.organization.allow_cobranding) {
          // GCG OA if co-branding opened, let enter
          next();
        } else {
          next({ name: 'dashboard' });
        }
      } else {
        next();
      }
    },
    meta: {
      roles: ['leader', 'coach', 'OA'],
      navMenuOptions: {
        index: '110-0',
        label: 'aside.settings',
        as: 'Settings',
        icon: 'el-icon-s-tools',
        standAlone: true,
        cobrandingCheck: !process.env.VUE_APP_COMPONENT_OA_SETTINGS,
      },
    },
  },
  {
    path: 'category',
    name: 'coachCategory',
    component: () => import(/* webpackChunkName: "dashboard" */ '../../../views/dashboard/content/coach/category/Category.vue'),
    meta: {
      roles: ['coach'],
      navMenuOptions: {
        parent: 'userSettings',
        index: '110-10',
        label: 'aside.coachCategory',
        hideForNonAc: true,
      },
    },
  },
];
